var exports = {
  "f": "tableLayoutFixed__5FTnfJ",
  "o": "compact__U6o-zW",
};

module.exports = exports;
